// Image gallery
document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', function() {
        const mainImg = document.querySelector('.gallery-main img');
        if (mainImg) {
            mainImg.src = this.dataset.url;
            mainImg.alt = this.dataset.alt || '';
        }
        const active = document.querySelector('.gallery-thumb.active');
        if (active) active.classList.remove('active');
        this.classList.add('active');
    });
});

// Variant selector (product page) — Shopify native
(function() {
    const variantSelect = document.getElementById('variant-select');
    const variantButtons = document.querySelectorAll('.variant-btn');
    const priceEl = document.querySelector('.product-detail-price');
    const addBtn = document.querySelector('.btn-add-to-cart');

    if (!variantSelect) return;

    // Read product JSON from the page
    const productJson = document.getElementById('product-json');
    let productData = null;
    if (productJson) {
        try { productData = JSON.parse(productJson.textContent); } catch(e) {}
    }

    // Button-style variant selector
    variantButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            const active = this.closest('.variant-options').querySelector('.active');
            if (active) active.classList.remove('active');
            this.classList.add('active');

            const variantId = this.dataset.variantId;
            if (variantId && variantSelect) {
                variantSelect.value = variantId;
            }

            // Update price
            if (productData && variantId) {
                const variant = productData.variants.find(v => String(v.id) === String(variantId));
                if (variant && priceEl) {
                    const formatted = new Intl.NumberFormat('sr-RS').format(Math.floor(variant.price / 100));
                    priceEl.innerHTML = formatted + ' <span>RSD</span>';
                }
                // Update availability
                if (addBtn) {
                    if (variant.available) {
                        addBtn.disabled = false;
                        addBtn.textContent = addBtn.dataset.addText || 'Dodaj u korpu';
                    } else {
                        addBtn.disabled = true;
                        addBtn.textContent = addBtn.dataset.soldText || 'Rasprodato';
                    }
                }
            }
        });
    });

    // Also handle native select change
    variantSelect.addEventListener('change', function() {
        if (productData) {
            const variant = productData.variants.find(v => String(v.id) === this.value);
            if (variant && priceEl) {
                const formatted = new Intl.NumberFormat('sr-RS').format(Math.floor(variant.price / 100));
                priceEl.innerHTML = formatted + ' <span>RSD</span>';
            }
            if (variant && addBtn) {
                if (variant.available) {
                    addBtn.disabled = false;
                    addBtn.textContent = addBtn.dataset.addText || 'Dodaj u korpu';
                } else {
                    addBtn.disabled = true;
                    addBtn.textContent = addBtn.dataset.soldText || 'Rasprodato';
                }
            }
        }
    });
})();
